
<canvas ref="weightChart" />
